module.exports = __webpack_public_path__ + "static/media/iconClose.326d5589.svg";